/* BRIVO theme — behaviour only. All content comes from Liquid sections. */
(function () {
  "use strict";
  var R = window.BRIVO || {};
  var S = R.strings || {};
  var FMT = R.moneyFormat || "{{amount_with_comma_separator}} €";

  /* ---------- money ---------- */
  function money(cents) {
    cents = Math.round(cents || 0);
    function num(dec, thou, places) {
      if (places === undefined) places = 2;
      var n = (cents / 100).toFixed(places), parts = n.split(".");
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return places ? i + dec + parts[1] : i;
    }
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case "amount": return num(".", ",");
        case "amount_no_decimals": return num("", ",", 0);
        case "amount_with_comma_separator": return num(",", " ");
        case "amount_no_decimals_with_comma_separator": return num("", " ", 0);
        case "amount_with_apostrophe_separator": return num(".", "'");
        case "amount_with_space_separator": return num(",", " ");
        case "amount_no_decimals_with_space_separator": return num("", " ", 0);
        default: return num(".", ",");
      }
    });
  }
  window.brivoMoney = money;

  /* ---------- toast / modal ---------- */
  var toastEl = document.getElementById("toast"), tT;
  function toast(m) {
    if (!toastEl) return;
    toastEl.textContent = m; toastEl.classList.add("show");
    clearTimeout(tT); tT = setTimeout(function () { toastEl.classList.remove("show"); }, 2600);
  }
  var modal = document.getElementById("modal");
  function openModal(t, p) {
    if (!modal) return;
    document.getElementById("modalT").textContent = t || "";
    document.getElementById("modalP").textContent = p || "";
    modal.classList.add("show");
  }
  function closeModal() { if (modal) modal.classList.remove("show"); }
  if (modal) {
    document.getElementById("modalX").addEventListener("click", closeModal);
    modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
  }

  /* ---------- header / nav / sticky ---------- */
  var hdr = document.getElementById("hdr"), burger = document.getElementById("burger"), mnav = document.getElementById("mnav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    Array.prototype.forEach.call(mnav.querySelectorAll("a"), function (a) {
      a.addEventListener("click", function () { mnav.classList.remove("open"); burger.setAttribute("aria-expanded", "false"); });
    });
  }
  var sat = document.getElementById("sat");
  function onScroll() {
    if (hdr) hdr.classList.toggle("stuck", window.scrollY > 8);
    if (sat) {
      var show = window.scrollY > 600 && window.innerWidth < 981;
      var last = document.querySelector(".fin");
      if (last) { var r = last.getBoundingClientRect(); if (r.top < window.innerHeight - 80) show = false; }
      sat.classList.toggle("show", show);
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  onScroll();

  /* ---------- gallery ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-gallery]"), function (gal) {
    var media = gal.querySelectorAll(".gal__s"), thumbs = gal.querySelectorAll(".th");
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener("click", function () {
        var i = t.getAttribute("data-i");
        Array.prototype.forEach.call(thumbs, function (x) { x.classList.toggle("on", x === t); });
        Array.prototype.forEach.call(media, function (m) { m.classList.toggle("on", m.getAttribute("data-i") === i); });
      });
    });
  });

  /* ---------- before / after ---------- */
  function rnd(seed) { var s = seed; return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
  function hairs(seed, color, n, w) {
    var r = rnd(seed), out = "";
    for (var i = 0; i < n; i++) {
      var x = 14 + r() * 372, y = 14 + r() * 272, l = 16 + r() * 44, a = r() * Math.PI * 2,
          cx = x + Math.cos(a) * l * .5 + (r() - .5) * 22, cy = y + Math.sin(a) * l * .5 + (r() - .5) * 22,
          ex = x + Math.cos(a) * l, ey = y + Math.sin(a) * l;
      out += '<path d="M' + x.toFixed(1) + ' ' + y.toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1) + '"/>';
    }
    return '<g stroke="' + color + '" stroke-width="' + w + '" fill="none" stroke-linecap="round" opacity=".85">' + out + '</g>';
  }
  function dots(seed, color, n) {
    var r = rnd(seed), out = "";
    for (var i = 0; i < n; i++) out += '<circle cx="' + (10 + r() * 380).toFixed(1) + '" cy="' + (10 + r() * 280).toFixed(1) + '" r="' + (.8 + r() * 2.1).toFixed(1) + '" fill="' + color + '" opacity="' + (.3 + r() * .5).toFixed(2) + '"/>';
    return out;
  }
  var FB = [
    { k: "sofa", base: "#C9BCA9", weave: "#B9A98F", st: '<path d="M0 92h400M0 210h400M132 92v118M268 92v118" stroke="#AD9C81" stroke-width="2.5" fill="none"/><rect width="400" height="46" fill="#B9A890"/>', db: hairs(11, "#3A2C22", 46, 1.9) + dots(7, "#5B4A3A", 40) },
    { k: "knit", base: "#1B2332", weave: "#252F42", st: '<g stroke="#2D3950" stroke-width="2.2" fill="none"><path d="M20 0v300M50 0v300M80 0v300M110 0v300M140 0v300M170 0v300M200 0v300M230 0v300M260 0v300M290 0v300M320 0v300M350 0v300M380 0v300"/></g>', db: hairs(23, "#D8D2C6", 52, 1.8) + dots(31, "#EAE6DC", 46) },
    { k: "car", base: "#4A505A", weave: "#575E69", st: '<path d="M0 66h400M0 238h400" stroke="#3D434C" stroke-width="3" fill="none"/><g stroke="#3D434C" stroke-width="2" stroke-dasharray="7 7" fill="none"><path d="M96 0v300M304 0v300"/></g>', db: hairs(47, "#1B1B1B", 40, 1.9) + hairs(53, "#C7BBA6", 22, 1.6) + dots(59, "#9AA2AE", 52) }
  ];
  function fbSvg(f, uid, withDebris) {
    var id = "w" + uid + (withDebris ? "b" : "a");
    return '<svg viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice">' +
      '<defs><pattern id="' + id + '" width="8" height="8" patternUnits="userSpaceOnUse">' +
      '<rect width="8" height="8" fill="' + f.base + '"/><path d="M0 4h8M4 0v8" stroke="' + f.weave + '" stroke-width="1" opacity=".55"/></pattern></defs>' +
      '<rect width="400" height="300" fill="url(#' + id + ')"/>' + f.st + (withDebris ? f.db : "") + '</svg>';
  }
  Array.prototype.forEach.call(document.querySelectorAll(".ba__v"), function (view, idx) {
    var before = view.querySelector(".ba__l--b"), after = view.querySelector(".ba__l--a");
    if (before && !before.children.length) {
      var f = FB[idx % FB.length];
      before.innerHTML = fbSvg(f, idx, true);
      if (after && !after.children.length) after.innerHTML = fbSvg(f, idx, false);
    }
    var r = view.querySelector(".ba__r");
    if (r) r.addEventListener("input", function () { view.style.setProperty("--p", r.value + "%"); });
  });

  /* ---------- video cards ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-placeholder]"), function (b) {
    b.addEventListener("click", function () {
      openModal("Място за видео", "Отвори тази секция в Customizer-а и качи вертикален клип 9:16 (MP4) или постави линк към YouTube/Vimeo.");
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-embed]"), function (b) {
    b.addEventListener("click", function () {
      var host = document.createElement("div");
      host.style.cssText = "position:absolute;inset:0;z-index:3";
      host.innerHTML = '<iframe src="' + b.getAttribute("data-video-embed") + '" allow="autoplay; fullscreen" allowfullscreen loading="lazy" title="Видео"></iframe>';
      b.appendChild(host);
      var p = b.querySelector(".vid__p"); if (p) p.style.display = "none";
    }, { once: true });
  });
  Array.prototype.forEach.call(document.querySelectorAll("[data-video-native]"), function (b) {
    b.addEventListener("click", function () {
      var v = b.querySelector("video"); if (!v) return;
      if (v.paused) { v.play(); b.querySelector(".vid__p").style.display = "none"; }
      else { v.pause(); b.querySelector(".vid__p").style.display = ""; }
    });
  });

  /* ---------- shipping cutoff ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-cutoff]"), function (box) {
    var out = box.querySelector("span"), H = parseInt(box.getAttribute("data-cutoff"), 10) || 16;
    function tick() {
      var now = new Date(), d = now.getDay(), h = now.getHours(), weekday = d >= 1 && d <= 5;
      if (weekday && h < H) {
        var end = new Date(now); end.setHours(H, 0, 0, 0);
        var mins = Math.floor((end - now) / 60000), hh = Math.floor(mins / 60), mm = mins % 60;
        out.innerHTML = "Поръчай до <b>" + H + ":00</b> и изпращаме днес — остават " + (hh > 0 ? hh + " ч и " : "") + mm + " мин.";
      } else if (weekday) {
        out.innerHTML = "Поръчките след <b>" + H + ":00</b> тръгват на следващия работен ден.";
      } else {
        out.innerHTML = "Днес е почивен ден — поръчката тръгва в <b>понеделник</b> сутрин.";
      }
    }
    tick(); setInterval(tick, 30000);
  });

  /* ---------- cart ---------- */
  var cartEl = document.getElementById("cart"), scrim = document.getElementById("scrim"),
      cBody = document.getElementById("cartBody"), cShipBar = document.getElementById("cartShip"), cc = document.getElementById("cc");
  var FREE = R.freeShip || 0;

  function openCart() { if (!cartEl) return; cartEl.classList.add("open"); scrim.classList.add("show"); cartEl.setAttribute("aria-hidden", "false"); }
  function closeCart() { if (!cartEl) return; cartEl.classList.remove("open"); scrim.classList.remove("show"); cartEl.setAttribute("aria-hidden", "true"); }
  var cartBtn = document.getElementById("cartBtn");
  if (cartBtn && cartEl) cartBtn.addEventListener("click", function (e) { e.preventDefault(); openCart(); refresh(); });
  var cx = document.getElementById("cartX"); if (cx) cx.addEventListener("click", closeCart);
  if (scrim) scrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeModal(); closeCart(); } });

  function drawCart(cart) {
    if (cc) { cc.textContent = cart.item_count; cc.hidden = cart.item_count === 0; }
    if (cBody) {
      if (!cart.items.length) {
        cBody.innerHTML = '<p class="cart__e">' + (S.empty || "") + '</p>';
      } else {
        var html = cart.items.map(function (l) {
          var img = l.image
            ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, "_140x$1$2") + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:contain">'
            : '<svg viewBox="0 0 420 420" width="56" height="56"><use href="#p-main"/></svg>';
          return '<div class="ci"><span class="ci__i">' + img + '</span>' +
            '<span><span class="ci__t">' + l.product_title + '</span>' +
            '<span class="ci__m">' + l.quantity + ' × ' + money(l.final_price) + '</span>' +
            '<button class="ci__r" type="button" data-key="' + l.key + '">' + (S.remove || "") + '</button></span>' +
            '<span class="ci__p">' + money(l.final_line_price) + '</span></div>';
        }).join("");
        /* upsell: one more of the main product, priced at the next tier */
        if (R.upsellId && R.tiers && R.tiers.length) {
          var main = cart.items.filter(function (l) { return String(l.product_id) === String(R.upsellProductId); })[0];
          if (main) {
            var q = main.quantity;
            var cur = tierFor(q), nxt = tierFor(q + 1);
            var delta = (nxt.unit * (q + 1)) - (cur.unit * q);
            if (delta > 0) {
              html += '<div class="ups"><span class="ups__i"><svg viewBox="0 0 420 420" width="42" height="42"><use href="#p-main"/></svg></span>' +
                '<span><span class="ups__t">Още един ' + (R.upsellName || "брой") + '</span>' +
                '<span class="ups__d">Само +' + money(delta) + ' — цената на брой пада на ' + money(nxt.unit) + '</span></span>' +
                '<button class="ups__a" type="button" id="upsAdd">Добави</button></div>';
            }
          }
        }
        cBody.innerHTML = html;
        Array.prototype.forEach.call(cBody.querySelectorAll("[data-key]"), function (b) {
          b.addEventListener("click", function () { change(b.getAttribute("data-key"), 0); });
        });
        var ua = document.getElementById("upsAdd");
        if (ua) ua.addEventListener("click", function () { addToCart(R.upsellId, 1); });
      }
    }
    if (cShipBar) {
      if (!FREE) cShipBar.hidden = true;
      else if (cart.total_price <= 0) cShipBar.innerHTML = "Безплатна доставка при поръчка над <b>" + money(FREE) + "</b>.<i style=\"--w:0%\"></i>";
      else if (cart.total_price >= FREE) cShipBar.innerHTML = '<b style="color:var(--ok)">' + (S.free || "") + '</b><i style="--w:100%"></i>';
      else cShipBar.innerHTML = "Още <b>" + money(FREE - cart.total_price) + "</b> " + (S.toFree || "") + '.<i style="--w:' + Math.min(100, cart.total_price / FREE * 100).toFixed(0) + '%"></i>';
    }
    var el;
    if ((el = document.getElementById("cSub"))) el.textContent = money(cart.items_subtotal_price);
    if ((el = document.getElementById("cTot"))) el.textContent = money(cart.total_price);
    var dRow = document.getElementById("cDiscRow");
    if (dRow) {
      var d = cart.total_discount || 0;
      dRow.hidden = d === 0;
      if ((el = document.getElementById("cDisc"))) el.textContent = "−" + money(d);
      var apps = cart.cart_level_discount_applications || [];
      if (apps.length && (el = document.getElementById("cDiscL"))) el.textContent = "Отстъпка (" + apps[0].title + ")";
      if (apps.length) {
        Array.prototype.forEach.call(document.querySelectorAll("[data-promo] .promo__m"), function (m) {
          m.className = "promo__m show ok";
          m.textContent = "Активен код: " + apps[0].title;
        });
      }
    }
  }
  function tierFor(q) {
    var best = R.tiers[0];
    R.tiers.forEach(function (t) { if (q >= t.qty) best = t; });
    return best;
  }
  function refresh() {
    return fetch(R.cartUrl + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).then(function (c) { drawCart(c); return c; }).catch(function () {});
  }
  function change(key, qty) {
    return fetch(R.changeUrl + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(drawCart).catch(function () { toast(S.error); });
  }
  var busy = false;
  function setBusy(on) {
    busy = on;
    Array.prototype.forEach.call(document.querySelectorAll("#atcBtn,#buyNow,#sBtn"), function (b) { b.disabled = on; b.classList.toggle("is-busy", on); });
  }
  function addItems(items, then) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return fetch(R.addUrl + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || S.error); });
      return r.json();
    }).then(refresh).then(function () {
      if (then === "checkout") { window.location.href = "/checkout"; return; }
      if (cartEl) openCart(); else window.location.href = R.cartUrl;
      toast(S.added);
    }).catch(function (e) { toast(e.message || S.error); }).then(function () { setBusy(false); });
  }
  function addToCart(id, quantity, props, then) {
    var it = { id: id, quantity: quantity };
    if (props) it.properties = props;
    return addItems([it], then);
  }
  window.brivoAdd = addToCart;
  if (cc) refresh();

  /* ---------- product form ---------- */
  var form = document.getElementById("brivoForm");
  if (form) {
    var bWrap = document.getElementById("bundles"), qtyEl = document.getElementById("qty"),
        vSel = document.getElementById("variantSelect"), bump = document.getElementById("bumpChk"),
        pxNow = document.getElementById("pxNow"), pxOld = document.getElementById("pxOld"), pxSave = document.getElementById("pxSave"),
        atcPrice = document.getElementById("atcPrice"), sLabel = document.getElementById("sLabel"),
        sPrice = document.getElementById("sPrice"), sOld = document.getElementById("sOld");
    var selected = null;

    function packs() { return Math.max(1, Math.min(20, parseInt(qtyEl ? qtyEl.value : 1, 10) || 1)); }
    function variantId() { if (selected && selected.getAttribute("data-kind") === "variant") return selected.getAttribute("data-variant"); return vSel ? vSel.value : form.getAttribute("data-variant"); }
    function bundleTiers() {
      if (!bWrap) return [];
      return Array.prototype.map.call(bWrap.querySelectorAll(".bd[data-kind='bundle']"), function (el) {
        return { qty: parseInt(el.getAttribute("data-qty"), 10) || 1, unit: parseInt(el.getAttribute("data-unit"), 10) || 0 };
      }).sort(function (a, b) { return a.qty - b.qty; });
    }
    function pick(el) {
      if (!el || el.getAttribute("aria-disabled") === "true") return;
      selected = el;
      if (vSel && el.getAttribute("data-kind") === "variant") vSel.value = el.getAttribute("data-variant");
      if (el.classList.contains("vc")) { el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); }
      Array.prototype.forEach.call(bWrap.querySelectorAll(".bd:not(.bd--todo),.vc"), function (x) {
        var on = x === el;
        x.classList.toggle("on", on);
        x.setAttribute("aria-checked", on ? "true" : "false");
      });
      render();
    }
    function render() {
      var unit = parseInt(form.getAttribute("data-price"), 10) || 0;
      var unitCmp = parseInt(form.getAttribute("data-compare"), 10) || unit;
      var q = selected ? parseInt(selected.getAttribute("data-qty"), 10) : 1;
      var units = q * packs();
      var total, cmp;
      if (selected && (selected.getAttribute("data-kind") === "combo" || selected.getAttribute("data-kind") === "variant")) {
        total = (parseInt(selected.getAttribute("data-total"), 10) || 0) * packs();
        cmp = (parseInt(selected.getAttribute("data-cmp"), 10) || total) * packs();
      } else {
        var list = bundleTiers(), per = selected ? parseInt(selected.getAttribute("data-unit"), 10) : unit;
        for (var i = 0; i < list.length; i++) if (units >= list[i].qty) per = list[i].unit;
        total = per * units; cmp = unitCmp * units;
        if (selected && packs() === 1) total = parseInt(selected.getAttribute("data-total"), 10) || total;
      }
      if (bump && bump.checked) {
        total += parseInt(bump.getAttribute("data-price"), 10) || 0;
        cmp += parseInt(bump.getAttribute("data-compare"), 10) || 0;
      }
      var save = cmp > total ? Math.round((1 - total / cmp) * 100) : 0;
      if (pxNow) pxNow.textContent = money(total);
      if (pxOld) { pxOld.textContent = money(cmp); pxOld.hidden = cmp <= total; }
      if (pxSave) { pxSave.textContent = "−" + save + "%"; pxSave.hidden = save <= 0; }
      if (atcPrice) atcPrice.textContent = money(total);
      if (sLabel) sLabel.textContent = (selected && (selected.getAttribute("data-kind") === "combo" || selected.getAttribute("data-kind") === "variant")) ? selected.getAttribute("data-name") : units + "× " + form.getAttribute("data-name");
      var ut = document.getElementById("unitsTotal");
      if (ut) ut.textContent = (packs() > 1 && !(selected && selected.getAttribute("data-kind") === "combo")) ? "Общо " + units + " ролки" : "";
      if (sPrice) sPrice.textContent = money(total);
      if (sOld) { sOld.textContent = money(cmp); sOld.hidden = cmp <= total; }
      if (window.brivoFsBars) window.brivoFsBars(total);
      var ss = document.getElementById("shipSum");
      if (ss && R.freeShip) {
        if (total >= R.freeShip) ss.innerHTML = "<b>Безплатна доставка</b> · крайна сума " + money(total);
        else ss.innerHTML = "+ " + money(R.shipCost || 0) + " доставка = <b>" + money(total + (R.shipCost || 0)) + "</b> · безплатна от " + money(R.freeShip);
      }
    }
    if (bWrap) {
      Array.prototype.forEach.call(bWrap.querySelectorAll(".bd:not(.bd--todo),.vc"), function (el) {
        el.addEventListener("click", function () { pick(el); });
        el.addEventListener("keydown", function (e) { if (e.key === " " || e.key === "Enter") { e.preventDefault(); pick(el); } });
      });
      pick(bWrap.querySelector(".bd.on:not(.bd--todo),.vc.on") || bWrap.querySelector(".bd:not(.bd--todo),.vc"));
    } else render();
    window.brivoRender = render;

    var qm = document.getElementById("qMinus"), qp = document.getElementById("qPlus");
    if (qm) qm.addEventListener("click", function () { qtyEl.value = Math.max(1, packs() - 1); render(); });
    if (qp) qp.addEventListener("click", function () { qtyEl.value = Math.min(20, packs() + 1); render(); });
    if (qtyEl) qtyEl.addEventListener("input", render);
    if (bump) bump.addEventListener("change", render);
    if (vSel) vSel.addEventListener("change", function () {
      var o = vSel.options[vSel.selectedIndex];
      form.setAttribute("data-price", o.getAttribute("data-price"));
      form.setAttribute("data-compare", o.getAttribute("data-compare"));
      render();
    });

    function submit(then) {
      if (selected && selected.getAttribute("data-items")) {
        var its; try { its = JSON.parse(selected.getAttribute("data-items")); } catch (e) { its = null; }
        if (its && its.length) {
          var k = packs();
          its.forEach(function (it) { it.quantity = (it.quantity || 1) * k; });
          if (bump && bump.checked) its.push({ id: bump.getAttribute("data-variant"), quantity: 1 });
          addItems(its, then);
          return;
        }
      }
      var id = variantId();
      if (!id) { toast(S.soldout); return; }
      var q = (selected ? parseInt(selected.getAttribute("data-qty"), 10) : 1) * packs();
      var props = null;
      if (selected && selected.getAttribute("data-gift")) props = { "Подарък": selected.getAttribute("data-gift") };
      var its2 = [{ id: id, quantity: q }];
      if (props) its2[0].properties = props;
      if (bump && bump.checked) its2.push({ id: bump.getAttribute("data-variant"), quantity: 1 });
      addItems(its2, then);
    }
    var atc = document.getElementById("atcBtn"); if (atc) atc.addEventListener("click", function (e) { e.preventDefault(); submit(); });
    var bn = document.getElementById("buyNow"); if (bn) bn.addEventListener("click", function (e) { e.preventDefault(); submit("checkout"); });
    var sb = document.getElementById("sBtn"); if (sb) sb.addEventListener("click", function (e) { e.preventDefault(); submit(); });
  }

  /* ---------- promo code (real Shopify /discount/ flow) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-promo]"), function (box) {
    var toggle = box.querySelector(".promo__t"), panel = box.querySelector(".promo__b"),
        input = box.querySelector(".promo__i"), go = box.querySelector(".promo__go"), msg = box.querySelector(".promo__m");
    if (!toggle || !panel || !input || !go) return;
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) input.focus();
    });
    function apply() {
      var code = input.value.trim();
      if (msg) msg.classList.add("show");
      if (!code) { if (msg) { msg.className = "promo__m show err"; msg.textContent = "Въведи код."; } return; }
      if (msg) { msg.className = "promo__m show ok"; msg.textContent = "Прилагаме кода " + code.toUpperCase() + "…"; }
      var back = window.location.pathname + window.location.search;
      window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(back);
    }
    go.addEventListener("click", apply);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); apply(); } });
  });

  /* ---------- брояч за оферта ---------- */
  function pad2(n) { return n < 10 ? "0" + n : "" + n; }
  Array.prototype.forEach.call(document.querySelectorAll("[data-timer]"), function (box) {
    var end = (parseInt(box.getAttribute("data-end"), 10) || 0) * 1000;
    if (!end) return;
    var dEl = box.querySelector("[data-d]"), hEl = box.querySelector("[data-h]"),
        mEl = box.querySelector("[data-m]"), sEl = box.querySelector("[data-s]"),
        srEl = box.querySelector("[data-sr]"), labEl = box.querySelector(".tm__l");
    var hide = box.getAttribute("data-hide") === "1";
    var expired = box.getAttribute("data-expired") || "";
    var iv = null;
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) {
        if (iv) clearInterval(iv);
        if (hide) { box.style.display = "none"; return; }
        box.setAttribute("data-done", "1");
        if (labEl) labEl.textContent = expired;
        if (srEl) srEl.textContent = expired;
        return;
      }
      var d = Math.floor(left / 86400),
          h = Math.floor((left % 86400) / 3600),
          m = Math.floor((left % 3600) / 60),
          sc = left % 60;
      if (dEl) dEl.textContent = pad2(d);
      if (hEl) hEl.textContent = pad2(h);
      if (mEl) mEl.textContent = pad2(m);
      if (sEl) sEl.textContent = pad2(sc);
      if (srEl && sc % 30 === 0) srEl.textContent = "Остават " + d + " дни и " + h + " часа.";
    }
    tick();
    iv = setInterval(tick, 1000);
  });

  /* ---------- лента „остава до безплатна доставка“ ---------- */
  function drawFsBars(cents) {
    Array.prototype.forEach.call(document.querySelectorAll("[data-fsbar]"), function (box) {
      var goal = parseInt(box.getAttribute("data-goal"), 10) || 0;
      if (!goal) { box.hidden = true; return; }
      var t = box.querySelector(".fsp__t"), fill = box.querySelector(".fsp__r i");
      var pct = Math.max(0, Math.min(100, (cents / goal) * 100));
      if (fill) fill.style.width = pct.toFixed(0) + "%";
      if (cents >= goal) {
        box.classList.add("ok");
        if (t) t.innerHTML = "Тази поръчка е с <b>безплатна доставка</b>.";
      } else {
        box.classList.remove("ok");
        if (t) t.innerHTML = "Още <b>" + money(goal - cents) + "</b> до безплатна доставка.";
      }
    });
  }
  window.brivoFsBars = drawFsBars;
  if (window.brivoRender) window.brivoRender();

  /* ---------- маркери [[...]] в редактора на темата ---------- */
  /* На сайта ги заменя сървърът. В Customizer-а секцията се презарежда сама, затова тук. */
  function fillTokens(root) {
    var T = R.tokens || {}, keys = Object.keys(T);
    if (!keys.length || !root) return;
    function sub(str) {
      if (!str || str.indexOf("[[") < 0) return str;
      keys.forEach(function (k) { str = str.split(k).join(T[k] || ""); });
      return str;
    }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { if (n.nodeValue.indexOf("[[") > -1) n.nodeValue = sub(n.nodeValue); }
    Array.prototype.forEach.call(root.querySelectorAll("[href*='[['],[placeholder*='[[']"), function (el) {
      if (el.hasAttribute("href")) el.setAttribute("href", sub(el.getAttribute("href")));
      if (el.hasAttribute("placeholder")) el.setAttribute("placeholder", sub(el.getAttribute("placeholder")));
    });
  }
  document.addEventListener("shopify:section:load", function (e) { fillTokens(e.target); });

  /* ---------- cart page quantity ---------- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-line-qty]"), function (box) {
    var key = box.getAttribute("data-line-qty"), input = box.querySelector("input");
    box.querySelector("[data-minus]").addEventListener("click", function () {
      window.location.href = R.changeUrl + "?id=" + encodeURIComponent(key) + "&quantity=" + Math.max(0, (parseInt(input.value, 10) || 1) - 1);
    });
    box.querySelector("[data-plus]").addEventListener("click", function () {
      window.location.href = R.changeUrl + "?id=" + encodeURIComponent(key) + "&quantity=" + ((parseInt(input.value, 10) || 1) + 1);
    });
  });
})();

/* v3.7: отзиви „виж всички“ и настройки за бисквитки */
(function () {
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-rv-more]");
    if (b) {
      var list = b.parentNode.querySelector("[data-rvl]");
      if (list) { var on = list.classList.toggle("all"); b.setAttribute("aria-expanded", on ? "true" : "false"); if (!b.dataset.label) b.dataset.label = b.textContent; b.textContent = on ? "Скрий" : b.dataset.label; }
    }
    var c = e.target.closest && e.target.closest("[data-cookie-prefs]");
    if (c && window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      e.preventDefault(); window.privacyBanner.showPreferences();
    }
  });
})();

/* v4.0: „Покажи още“ за описанието */
document.addEventListener("click", function (e) {
  var b = e.target.closest && e.target.closest("[data-more]");
  if (!b) return;
  var box = b.previousElementSibling;
  if (box) { var on = box.classList.toggle("open"); b.textContent = on ? "Покажи по-малко" : "Покажи още"; }
});
